<template>
    <div class="modal-goodslist">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">App版本修改</div>
                <button type="button" class="btn-close" @click="closeSelf">关闭</button>
            </div>
            <div class="modal-body">
                <el-form :model="editForm" :rules="rules" ref="editForm">
                    <div>
                        <el-row>
                            <el-col :span="12" class="item">
                                <el-form-item label="App名称" required prop="name">
                                    <el-input v-model="editForm.name" placeholder="请输入App名称"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="item">
                                <el-form-item label="版本号" required prop="version">
                                    <el-input v-model="editForm.version" placeholder="请输入版本号"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                             <el-col :span="12" class="item">
                                <el-form-item label="Apk路径" required prop="url">
                                    <el-input v-model="editForm.url" placeholder="请输入Apk路径"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>
                </el-form>
            </div>
            <div class="modal-footer">
                <el-button :loading="loading" type="primary" @click="confirm('editForm')">修改</el-button>
            </div>
        </div>
    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";


    export default {
        name: 'Edit',
        props:['attributeList'],
        data() {
            return {
                loading: false,
                iconDialog: false,
                editForm:{
                    timeStr:timeStr,
                    sign:'',
                    staffCode:getStaffCode(),
                    name:'',
                    version:'',
                    url:'',
                    versionCode:''
                },
                rules:{
                    name:[
                        { required: true, message: '请输入App名称', trigger: 'blur' },
                    ],
                    version:[
                        { required: true, message: '请输入版本号', trigger: 'blur' },
                    ],
                    url:[
                        { required: true, message: '请输入Apk路径', trigger: 'blur' },
                    ]

                }

            }
        },
        methods: {
            init(row){
                this.editForm.versionCode = row.versionCode;
                this.editForm.name = row.name;
                this.editForm.version = row.version;
                this.editForm.url = row.url;
            },
            closeSelf() {
                this.$emit("closeEdit");
            },
            confirm(editForm){
                this.$refs[editForm].validate((valid) => {
                    if(valid){
                        this.addSubmit();
                    }else {
                        console.log('error submit!!');
                        return false;
                    }
                })
            },
            changeStatus:function (selVal) {
                this.editForm.status = selVal;
            },
            iconPreview() {
                this.iconDialog = true;
            },
            addSubmit(){

                if(this.loading){
                    return;
                }else{
                    this.loading = true;
                }

                this.editForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"Version/Edit",
                    data: this.editForm
                }).then(
                    (response) => {
                        this.loading = false;

                        if (response.data.error == 0) {
                            this.$emit("closeEdit");
                            this.$emit("getList");
                        }else if(response.data.error == 1){
                            this.$message.error(response.data.message)
                        }
                    }
                )
            },

        }
    }


</script>




<style lang="scss" scoped>

    .modal-goodslist {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0,0,0,.3);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 99;

        .modal {
            background-color: #fff;
            box-shadow:  0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
            overflow-x:auto;
            display: flex;
            flex-direction: column;
            border-radius: 10px;
            width: 600px;
            .modal-body /deep/ .el-upload--picture-card{
                width: 100px;
                height: 100px;
                line-height: 100px;
            }
            .modal-header {
                border-bottom: 1px solid #eee;
                color: #313131;
                justify-content: space-between;
                padding: 10px;
                display: flex;
            }
             .modal-body .avatar-uploader .el-upload {
                border: 1px dashed #d9d9d9;
                border-radius: 6px;
                cursor: pointer;
                position: relative;
                overflow: hidden;
                width:100px;
                height: 100px;
            }
            .modal-body .avatar-uploader .el-upload:hover {
                border-color: #409EFF;
            }
            .modal-body .avatar-uploader-icon {
                font-size: 28px;
                color: #8c939d;
                width: 100px;
                height: 100px;
                line-height: 100px;
                text-align: center;
            }
            .modal-body .avatar {
                width: 100%;
                height: 100%;
                border-radius: 6px;
                display: block;
            }
            .modal-body {
                position: relative;
                padding: 20px 0px;
                z-index: 99;
                height: 100%;
            }
            .modal-footer {
                border-top: 1px solid #eee;
                justify-content: flex-end;
                padding: 15px;
                display: flex;
            }
            .uploadButton{
                border-top: 1px solid #eee;
                padding: 10px 0 0;
                display: flex;
                 .el-button{
                    width: 100px;
                }
            }

        }

    }


    .btn-close, .btn-confirm {
        border-radius: 8px;
        margin-left:16px;
        width:56px;
        height: 36px;
        border:none;
        cursor: pointer;
    }
    .btn-close {
        color: #313131;
        background-color:transparent;
    }



    .row{
        padding: 10px 0px;
    }
    .item{
        padding: 0px 20px;
    }
    .label{
        padding: 5px 0px;
    }


</style>
